import { Outlet } from 'react-router-dom';
import { SkipToContent } from '@/components/SkipToContent';
import { FloatingCTAActions } from '@/components/FloatingCTAActions';
import { Footer } from '@/components/Footer';
import { PublicLayoutHeader } from './PublicLayoutHeader';

export function PublicLayout() {
  return (
    <div className="layout layout--public">
      <SkipToContent />
      <PublicLayoutHeader />

      <main id="main-content" className="layout__main" tabIndex={-1}>
        <Outlet />
      </main>

      <Footer />
      <FloatingCTAActions />
    </div>
  );
}
